var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"svg-icon"},[_c('svg',{attrs:{"viewBox":_vm.viewBox,"role":"img","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.href}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }